exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.update[data-v-5dc9b272] {\n\twidth: auto;\n}\n", ""]);
